// Регистрируем SW только в проде — в dev кеш мешает hot-reload.
export function registerSW(): void {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Регистрация SW не критична для работы приложения — молча игнорируем сбой.
      void 0;
    });
  });
}
